export enum CompanyTabEnum {
  FIND_CANDIDATES = 'find-candidates',
  JOB_POSTS = 'job-posts',
  CULTURE_PROFILES = 'culture-profiles',
  CANDIDATE_OVERVIEW = 'candidate-overview',
  CAREER_PAGE = 'career-page'
}
